import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function TeletravailServiceAdministratif({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        Bonjour {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>Qu'en pensez-vous ?</p>
      <p>
        Je suis personnellement contre ces initiatives qui ne peuvent nous
        apporter que des déboires et de la désorganisation.
      </p>
      <p>Cordialement.</p>
      <MailSignature
        emetteurLogo={TeletravailServiceAdministratif.metadata.emetteurLogo}
        emetteur={TeletravailServiceAdministratif.metadata.emetteur}
        emetteurPoste={TeletravailServiceAdministratif.metadata.emetteurPoste}
        emetteurEntreprise={
          TeletravailServiceAdministratif.metadata.emetteurEntreprise
        }
      />
      <div className="mt-6">
        <div className="italic">Message transféré :</div>
        <div className="mt-2 space-y-4 border-l-4 border-gray-300 pl-4 text-gray-600">
          <p>
            Suite à de nombreuses discussions entre employés, nous avons convenu
            qu'il serait intéressant d'instaurer un système d'horaires variables
            au sein des services administratifs. En effet, si certaines
            personnes préfèrent arriver plus tard le matin, d'autres trouvent
            plus intéressant de quitter leur travail plus tôt. Tenant compte des
            jeunes récemment recrutés (génération Z), nous pensons qu'il serait
            tout à fait possible d'adopter un système plus flexible intégrant
            les désirs de chacun et pourquoi pas mettre en place une
            expérimentation de télétravail. Ces propositions pourraient avoir un
            effet positif sur l'ambiance et la motivation du personnel.
          </p>
          <p>
            Concernant le projet de télétravail, j'ai réalisé une enquête
            personnelle et j'ai repéré une dizaine de personnes potentiellement
            intéressées sur la base de 2 jours par semaine. J'aurais besoin de
            votre aval pour une étude plus approfondie (coûts, faisabilités
            techniques, avantages).
          </p>
          <p>
            Je souhaiterais vous rencontrer afin de vous les présenter d'une
            manière précise.
          </p>
          <div>
            <p className="font-bold">
              {variablesData.collaborateur_1_prenom}{" "}
              {variablesData.collaborateur_1_nom}
            </p>
            <p>{variablesData.collaborateur_1_fonction}</p>
            <p>{variablesData.collaborateur_1_societe}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

TeletravailServiceAdministratif.metadata = {
  titre: "Mise en place du télétravail au sein du service administratif",
  cleMail: "teletravail_service_administratif",
  messageTransfert: true,
  emetteur: "François AS",
  emetteurPoste: "Responsable Administratif",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: 0,
  piecesJointes: [
    "projet-mise-en-place-teletravail",
    "projet-horaires-variables",
  ],
} as MailMetadata;

export default TeletravailServiceAdministratif;
